import * as React from 'react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

export interface SubmenuProps {
    open: boolean;
    children?: React.ReactNode;
}

export interface InjectedSubmenuProps {
    open: boolean;
    closeSubmenu(): void;
}

export default class ActionSubmenu extends React.Component<SubmenuProps, any> {
    render() {
        const {open, children} = this.props;
        return open ? <div className="action-details">{children}</div> : null;
    }
}

export interface AnimatedSubmenuProps extends SubmenuProps {
    transitionName?: string;
    transitionEnterTimeout?: number;
    transitionLeaveTimeout?: number;
}

export class AnimatedActionSubmenu extends React.Component<AnimatedSubmenuProps, any> {
    render() {
        const {open, children} = this.props;
        const {
            transitionName = 'action-submenu',
            transitionEnterTimeout = 500,
            transitionLeaveTimeout = 500
        } = this.props;
        return (
            <TransitionGroup>
                {open && (
                    <CSSTransition
                        classNames={transitionName}
                        timeout={{enter: transitionEnterTimeout, exit: transitionLeaveTimeout}}
                    >
                        <div key="submenu" className="action-details">
                            {children}
                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
        );
    }
}
